<template>
  <div>
    <window title="Vue Gallery <a target='_blank' href='https://github.com/RobinCK/vue-gallery' target='_blank'>(more info)</a>">
      <div class="columns">
        <div class="column">
          <span class="subtitle is-6">
            Responsive and customizable image and video gallery, carousel and lightbox,
            optimized for both mobile and desktop web browsers.
          </span>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <gallery :images="images" :index="index" @close="index = null"></gallery>
          <div class="image" v-for="(image, imageIndex) in images" :key="imageIndex"
          @click="index = imageIndex" :style="{ backgroundImage: 'url(' + image + ')'}"></div>
        </div>
      </div>
    </window>
    <window :title="currentCarousel + ' Carousel ' + '<a target=\'_blank\' href=\'https://ssense.github.io/vue-carousel/\'>(more info)</a>'">
      <div class="columns is-multiline is-mobile">
        <div class="column is-centered is-full-mobile is-three-quarters">
          <div v-show="carousel[0].name == currentCarousel">
            <carousel :autoplay="true" :autoplayTimeout="1000">
              <slide><span class="label is-primary has-text-centered">1</span></slide>
              <slide><span class="label is-primary has-text-centered">2</span></slide>
              <slide><span class="label is-primary has-text-centered">3</span></slide>
              <slide><span class="label is-primary has-text-centered">4</span></slide>
              <slide><span class="label is-primary has-text-centered">5</span></slide>
              <slide><span class="label is-primary has-text-centered">6</span></slide>
              <slide><span class="label is-primary has-text-centered">7</span></slide>
              <slide><span class="label is-primary has-text-centered">8</span></slide>
            </carousel>
          </div>
          <div v-show="carousel[1].name == currentCarousel">
             <carousel :perPageCustom="[[480, 2], [768, 3]]">
              <slide><span class="label is-primary has-text-centered">1</span></slide>
              <slide><span class="label is-primary has-text-centered">2</span></slide>
              <slide><span class="label is-primary has-text-centered">3</span></slide>
              <slide><span class="label is-primary has-text-centered">4</span></slide>
              <slide><span class="label is-primary has-text-centered">5</span></slide>
              <slide><span class="label is-primary has-text-centered">6</span></slide>
              <slide><span class="label is-primary has-text-centered">7</span></slide>
              <slide><span class="label is-primary has-text-centered">8</span></slide>
            </carousel>
          </div>
          <div v-show="carousel[2].name == currentCarousel">
            <carousel :scrollPerPage="true" :perPageCustom="[[480, 2], [768, 3]]">
              <slide><img src="https://picsum.photos/300/100?image=0" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=10" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=20" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=30" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=40" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=50" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=60" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=70" style="max-width: 100%;"></slide>
              <slide><img src="https://picsum.photos/300/100?image=80" style="max-width: 100%;"></slide>
            </carousel>
          </div>
          <div v-show="carousel[3].name == currentCarousel">
           <carousel :scrollPerPage="false">
              <slide><span class="label is-primary has-text-centered">1</span></slide>
              <slide><span class="label is-primary has-text-centered">2</span></slide>
              <slide><span class="label is-primary has-text-centered">3</span></slide>
              <slide><span class="label is-primary has-text-centered">4</span></slide>
              <slide><span class="label is-primary has-text-centered">5</span></slide>
              <slide><span class="label is-primary has-text-centered">6</span></slide>
              <slide><span class="label is-primary has-text-centered">7</span></slide>
              <slide><span class="label is-primary has-text-centered">8</span></slide>
            </carousel>
          </div>
          <div v-show="carousel[4].name == currentCarousel">
            <carousel :navigationEnabled="true">
              <slide><span class="label is-primary has-text-centered">1</span></slide>
              <slide><span class="label is-primary has-text-centered">2</span></slide>
              <slide><span class="label is-primary has-text-centered">3</span></slide>
              <slide><span class="label is-primary has-text-centered">4</span></slide>
              <slide><span class="label is-primary has-text-centered">5</span></slide>
              <slide><span class="label is-primary has-text-centered">6</span></slide>
              <slide><span class="label is-primary has-text-centered">7</span></slide>
              <slide><span class="label is-primary has-text-centered">8</span></slide>
            </carousel>
          </div>
        </div>
        <div class="column has-text-centered">
          <b-field label="Select carousel">
            <b-select v-model="currentCarousel" class="has-text-centered" placeholder="Carousel">
              <option v-for="option in carousel" :value="option.name" :key="option.name">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </window>
  </div>
</template>

<script>
import Gallery from 'vue-gallery';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Galleries',
  data: () => ({
    images: [
      'https://picsum.photos/800/800?image=50',
      'https://picsum.photos/1600/1600?image=11',
      'https://picsum.photos/1280/1280?image=22',
      'https://picsum.photos/400/400?image=33',
    ],
    currentCarousel: 'Autoplay',
    carousel: [
      { active: true, name: 'Autoplay' },
      { active: false, name: 'Basic' },
      { active: false, name: 'Responsive' },
      { active: false, name: 'Single item scroll' },
      { active: false, name: 'Navigation' },
    ],
    index: null,
  }),
  components: {
    gallery: Gallery,
    Carousel,
    Slide,
  },
};
</script>

<style scoped>
.columns {
  padding: 1rem;
}
@media only screen and (min-width: 1576px) {
  .image {
    width: 300px;
    height: 200px;
    display: inline-flex;
    background-position: center;
    background-size: cover;
  }
}

@media only screen and (max-width: 1575px) {
  .image {
    width: 120px;
    height: 200px;
    display: inline-flex;
    background-position: center;
    background-size: cover;
  }
}
.VueCarousel-slide {
  position: relative;
  margin: 1px;
  font-family: Arial;
  font-size: 24px;
  text-align: center;
  min-height: 100px;
}
.label {
  height: 100%;
}
</style>
